import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  PostedARRegisterCriteriaBean,
  PostedARRegisterPrintRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";

import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import CustomTable from "../gui_components/CustomTable.js";
class PostedARACHPaymentRegister extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Posted AR ACH Payment Register Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new PostedARRegisterCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      inquiryData: null,
      postDatedCheckList: [],
      salesPersons: [],
      checkDateFlag: true,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      isDisableFields: false,
      isCollapsible_open: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    let criteria = this.state.criteria;
    var date = new Date();
    var firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    criteria.startAccountReceivableDate = firstDate;
    this.setState({
      criteria: criteria,
    });
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.state.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    if (e.target.name == "salesPersonCode") {
      this.state.salesPersons.map((list, i) => {
        if (list.code === e.target.value) {
          criteria.salesPersonName = list.description;
        }
      });
    }
    this.setState({ criteria: criteria });
  };
  dateOnChange = (e) => {
    let checkDateFlag = e.target.value;
    this.setState({ checkDateFlag: checkDateFlag });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let checkDateFlag = this.state.checkDateFlag;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (checkDateFlag === false) {
      criteria.startAccountReceivableDate = "";
      if (
        !isEmptyString(criteria.startPostedDate) &&
        !isEmptyString(criteria.endPostedDate)
      ) {
        this.loadPostedARACHPaymentRegisterInquiryList(criteria);
      } else {
        let errMsg = "Enter Date Range";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isLoading: false,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    } else {
      if (
        !isEmptyString(criteria.startAccountReceivableDate) &&
        !isEmptyString(criteria.stopAccountReceivableDate)
      ) {
        this.loadPostedARACHPaymentRegisterInquiryList(criteria);
      } else {
        let errMsg = "Enter Date Range";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isLoading: false,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadPostedARACHPaymentRegisterInquiryList = (criteria) => {
    if (
      SecurityAccessManager.PostedARACHPaymentRegisterInquiry_IsAccessible()
    ) {
      ReportService.inquirePostedARPaymentRegister(
        criteria,
        this.loadPostedARACHPaymentRegisterPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadPostedARACHPaymentRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryData = response.data.result;
      let arDataList = [];
      let finalList = [];
      let bouncedCheckList = [];
      if (!isEmptyArray(response.data.result.detailsInfo)) {
        arDataList = response.data.result.detailsInfo;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
        arDataList.map((ln) => {
          if (ln.bouncedCheck == true) {
            bouncedCheckList.push(ln);
            // this.setState({
            //   isShowPDFButton: true,
            //   isShowExcelButton: true,
            // });
          }
        });
        arDataList.map((li) => {
          if (li.autoClearingHouseAmount > 0) {
            finalList.push(li);
          }
        });
        if (isEmptyArray(finalList)) {
          let errMsg = "No Posted AR Details !";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
            isShowPDFButton: false,
            isShowExcelButton: false,
          });
        }
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        // inquiryDataList: arDataList,
        inquiryDataList: finalList,
        inquiryData: inquiryData,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowClearCriteriaButton: false,
        bouncedCheckList: bouncedCheckList,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PostedARRegisterPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PostedARACHPaymentRegisterInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generatePostedARPaymentRegisterPrintReport(
          listRequest,
          this.generatePostedARPaymentRegisterPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PostedARACHPaymentRegisterInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generatePostedARPaymentRegisterPrintReport(
          listRequest,
          this.generatePostedARPaymentRegisterPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    }
  };
  generatePostedARPaymentRegisterPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generatePostedARPaymentRegisterPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
       let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new PostedARRegisterCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.isCheckBounceFlag = false;
    criteria.salesPersonName = "";
    criteria.customerName = "";
    var date = new Date();
    var firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    criteria.startAccountReceivableDate = firstDate;
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new PostedARRegisterCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.isCheckBounceFlag = false;
    criteria.salesPersonName = "";
    criteria.customerName = "";
    var date = new Date();
    var firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    criteria.startAccountReceivableDate = firstDate;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
      checkDateFlag: true,
    });
    this.hideAlertCallBack();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ salesPersonList: salesPersonBean });
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("ARDate", "accountReceivableDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewARModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PostedDate", "accountReceivablePostedDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Po#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonDetails", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ACH Amt", "autoClearingHouseAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ACH Ref#", "paidAutoClearingHouseReferenceNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ACH Date", "achDate", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          dateOnChange={this.dateOnChange}
          customerCodeOnChange={this.customerCodeOnChange}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const dateOnChange = (e) => props.dateOnChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let checkDateFlag = props.checkDateFlag;
  let customerLookupHandler = props.customerLookupHandler;
  let customerCodeRef = React.createRef();
  let salesPersonLookupHandler = props.salesPersonLookupHandler;
  let salesPersonCodeRef = React.createRef();
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const salesPersonEnterKeyEventHandler = (e) => {
    props.salesPersonEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesPersonList = () => {
    props.displayAutoCompleteSalesPersonList();
  };
  const salesPersonCodeOnChange = (e) => {
    props.salesPersonCodeOnChange(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        {checkDateFlag === true && (
          <Col sm="1">
            <FormLabel> AR </FormLabel>
          </Col>
        )}
        {checkDateFlag === false && (
          <Col sm="1">
            <FormLabel> PostedDate </FormLabel>
          </Col>
        )}
        <Col sm="1">
          <InputCheckbox
            name="checkDateFlag"
            checked={checkDateFlag}
            onChange={dateOnChange}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        {checkDateFlag === true && (
          <Col sm="1">
            {" "}
            <FormLabel>Start ARDate</FormLabel>
          </Col>
        )}
        {checkDateFlag === true && (
          <Col sm="2">
            <DatePickerComponent_adv
              name="startAccountReceivableDate"
              value={criteria.startAccountReceivableDate}
              onChange={onChange}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        )}
        {checkDateFlag === true && (
          <Col sm="1">
            <FormLabel>End ARDate</FormLabel>
          </Col>
        )}
        {checkDateFlag === true && (
          <Col sm="2">
            <DatePickerComponent_adv
              name="stopAccountReceivableDate"
              onChange={onChange}
              value={criteria.stopAccountReceivableDate}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        )}
        {checkDateFlag === false && (
          <Col sm="1">
            <FormLabel>Start PostedDate</FormLabel>
          </Col>
        )}
        {checkDateFlag === false && (
          <Col sm="2">
            <DatePickerComponent_adv
              name="startPostedDate"
              value={criteria.startPostedDate}
              onChange={onChange}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        )}
        {checkDateFlag === false && (
          <Col sm="1">
            <FormLabel>End PostedDate</FormLabel>
          </Col>
        )}
        {checkDateFlag === false && (
          <Col sm="2">
            <DatePickerComponent_adv
              name="endPostedDate"
              onChange={onChange}
              value={criteria.endPostedDate}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        )}
        <Col sm="1">
          <FormLabel>SalesPerson</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesPersonCodeRef}
            name="salesPersonCode"
            onChange={salesPersonCodeOnChange}
            value={criteria.salesPersonCode}
            lookupRequired={true}
            lookupHandler={salesPersonLookupHandler}
            enterKeyEventHandler={salesPersonEnterKeyEventHandler}
            autoCompleteListData={props.salesPersonPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesPersonList}
            showAutoCompleteList={props.showAutoCompleteSalesPersonList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="2"></Col>
          <Col sm="3">
            <InputTextbox
              name="salesPersonName"
              onChange={onChange}
              value={criteria.salesPersonName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Customer</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={customerCodeRef}
              name="customerCode"
              onChange={customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={customerCodeEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteList}
              showAutoCompleteList={props.showAutoCompleteCustomerList}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="customerName"
              onChange={onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function PostedARACHPaymentRegisterInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <PostedARACHPaymentRegister {...props} name="" /> <br />
    </div>
  );
}

export default PostedARACHPaymentRegisterInquiry;
